import script from "./WorkflowSettingsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowSettingsModal.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowSettingsModal.vue?vue&type=style&index=0&id=7b31fb5b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b31fb5b"]])

export default __exports__